import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import compose from 'recompose/compose';
import {withRouter} from 'react-router-dom';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import {FormattedMessage} from 'react-intl';
import {Menu, Grid, Button} from 'semantic-ui-react';
import setDisplayName from 'recompose/setDisplayName';
import {Route, Switch, NavLink} from 'react-router-dom';
import * as ViewOptionsActions from 'viewOptions/actions';
import StatusModal from 'components/common/StatusModal';
import {PermissionsFilter} from 'hoc/authorization';
import SiteMenu from 'components/common/SiteMenu';
import {getPrizeEntryFilters} from './selectors';
import ListWinnersPage from './ListWinnersPage';
import {SupportedLangs} from 'utils/DBUtils';
import * as ResourceApi from 'api/resources';
import * as WinnersActions from './actions';
import winnersTableConfigs from './configs';
import Config from 'Config';

const LockedListWinnersPage = PermissionsFilter({
  [ResourceApi.Types.PrizeEntry]: ['READ'],
  [ResourceApi.Types.Prize]: ['READ']
})(ListWinnersPage);

const mapStateToProps = state => {
  // assume only one
  const currentFilter = getPrizeEntryFilters(state).find(filter => includes(SupportedLangs, filter.value));
  const currentLang = currentFilter.value;

  const {publishingFeaturedWinners, isPublishFeaturedModalOpen} = state.listWinners;

  return {
    currentFilter,
    currentLang,
    publishingFeaturedWinners,
    isPublishFeaturedModalOpen
  };
};

const mapDispatchToProps = {
  setFilters: ViewOptionsActions.setRawFiltersForResourceAction,
  requestWinners: WinnersActions.requestWinnersAction,
  submitPublishWinners: WinnersActions.submitPublishFeaturedAction,
  closePublishFeaturedModal: WinnersActions.closePublishErrorModalAction
};

export default compose(
  setDisplayName('ListWinnersNav'),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withProps(props => ({
    winnersTableConfig: winnersTableConfigs[props.match.params.prizeType],
    previewURL: `${Config.ENV_PREVIEW_SITE_PREFIX[props.currentLang]}rewards/winners`,
    publishWinners: () => props.submitPublishWinners(props.currentLang),
    setLang: lang => {
      const filter = {field: 'lang', value: lang};
      props.setFilters(ResourceApi.Types.PrizeEntry, [filter], {winnersOnly: true});
    }
  })),
  lifecycle({
    componentDidMount() {
      const {prizeType, defaultSort} = this.props.winnersTableConfig;
      this.props.requestWinners(prizeType, defaultSort);
    },
    componentWillReceiveProps(nextProps) {
      // config/route/prizeType changed, so re-fetch winners and provide the correct default sort.
      if (nextProps.winnersTableConfig.prizeType !== this.props.winnersTableConfig.prizeType) {
        const {prizeType, defaultSort} = nextProps.winnersTableConfig;
        this.props.requestWinners(prizeType, defaultSort);
      }
    }
  })
)(props => (
  <React.Fragment>
    <Grid>
      <Grid.Row>
        <Grid.Column width={8} textAlign='left'>
          <Menu tabular className='list-winners-nav'>
            <Menu.Item
              as={NavLink}
              to='/winners/editorial'
              content={<FormattedMessage id='winnersList.nav.tab.sweepsWinners' />}
              activeClassName='active' />
            <hr/>
            <Menu.Item
              as={NavLink}
              to='/winners/sponsored'
              content={<FormattedMessage id='winnersList.nav.tab.sponsoredWinners' />}
              activeClassName='active' />
          </Menu>
        </Grid.Column>
        <Grid.Column width={8} textAlign='right'>
          <Grid columns={3} className='list-winners-controls'>
            <Grid.Row>
              <Grid.Column width={8}>
                <SiteMenu lang={props.currentLang} selectLang={props.setLang} />
              </Grid.Column>
              <Grid.Column width={4} stretched>
                <Button
                  primary
                  as='a'
                  target='_blank'
                  href={props.previewURL}>
                  <FormattedMessage id='buttons.preview' />
                </Button>
              </Grid.Column>
              <Grid.Column width={4} stretched>
                <Button
                  primary
                  onClick={props.publishWinners}
                  loading={props.publishingFeaturedWinners}
                  disabled={props.publishingFeaturedWinners}>
                  <FormattedMessage id='buttons.publish' />
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Switch>
      <Route exact path='/winners/editorial' render={() => <LockedListWinnersPage {...props} />} />
      <Route exact path='/winners/sponsored' render={() => <LockedListWinnersPage {...props} />} />
    </Switch>
    {props.isPublishFeaturedModalOpen && (
      <StatusModal
        isOpen={props.isPublishFeaturedModalOpen}
        onClose={props.closePublishFeaturedModal}
        className='publish-error-modal'
        size='tiny'
        success={false}
        errorHeaderKey='error'
        errorMessageKey={`winnersList.error.publishFeatured.${props.currentLang}`} />
    )}
  </React.Fragment>
));



// WEBPACK FOOTER //
// ./public/pages/ListWinners/ListWinnersNav.jsx